<template>
  <header
    class="header-expanded py-6 px-5 relative box-border w-full"
    :class="$dm('bg-white', 'dark:bg-slate-950')"
  >
    <div
      class="flex items-start"
      :class="[avatarUrl ? 'justify-between' : 'justify-end']"
    >
      <img
        v-if="avatarUrl"
        class="h-12 rounded-full"
        :src="avatarUrl"
        alt="Avatar"
      />
      <header-actions
        :is-in-message-screen="true"
        :show-popout-button="showPopoutButton"
      />
    </div>
    <h2
      v-dompurify-html="headingText"
      :title="introHeading"
      class="mt-5 text-3xl mb-3 font-normal break-words"
      :class="$dm('text-slate-900', 'dark:text-slate-50')"
    />
    <p
      v-dompurify-html="introBody"
      class="text-lg leading-normal break-words"
      style="max-height: 120px; overflow-y: auto"
      :class="$dm('text-slate-700', 'dark:text-slate-200')"
    />
  </header>
</template>

<script>
import { mapGetters } from 'vuex';
import HeaderActions from './HeaderActions';
import darkModeMixin from 'widget/mixins/darkModeMixin.js';

export default {
  name: 'ChatHeaderExpanded',
  components: {
    HeaderActions,
  },
  mixins: [darkModeMixin],
  props: {
    avatarUrl: {
      type: String,
      default: '',
    },
    introHeading: {
      type: String,
      default: '',
    },
    introBody: {
      type: String,
      default: '',
    },
    showPopoutButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      windowHeight: window.innerHeight,
    };
  },
  computed: {
    ...mapGetters({
      widgetColor: 'appConfig/getWidgetColor',
    }),
    headingText() {
      return this.checkHeight();
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize); // Cleanup when the component is destroyed
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
    this.checkHeight();
  },
  methods: {
    handleResize() {
      this.windowHeight = window.innerHeight;
      this.checkHeight();
    },
    checkHeight() {
      if (this.windowHeight <= 600) {
        return this.calculateHeight(Math.round(this.windowHeight / 10));
      }
      return this.calculateHeight(150);
    },
    calculateHeight(maxLength) {
      if (this.introHeading.length >= maxLength) {
        return this.introHeading.slice(0, maxLength) + '...';
      }
      return this.introHeading;
    },
  },
};
</script>
